/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { CarouselContext } from '../context/CarouselContext';
import * as styles from '../ScrollingCarousel.styles';
import type { ScrollingCarouselStepProps } from '../ScrollingCarousel.types';

export const ScrollingCarouselStep = ({
  children,
  index,
  className,
  parentId,
  onClick,
  itemWidth,
  ariaLabel,
}: ScrollingCarouselStepProps) => {
  const context = useContext(CarouselContext);

  if (!context) {
    throw new Error(
      'ScrollingCarouselStep must be used within ScrollingCarousel'
    );
  }

  const { carousel, dispatch } = context;
  const [ref, inView] = useInView({
    threshold: 0.75,
    root: carousel.current,
  });

  useEffect(() => {
    if (typeof index !== 'undefined') {
      dispatch({
        type: 'set_child_visibility',
        payload: { index, visible: inView },
      });
    }
  }, [inView, index, dispatch]);

  return (
    <div
      ref={ref}
      css={styles.step(itemWidth)}
      className={className}
      data-carousel-id={parentId}
      data-carousel-index={index}
      onClick={onClick}
      role="group"
      aria-roledescription="slide"
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
};

ScrollingCarouselStep.displayName = 'ScrollingCarouselStep';
